module.exports = __webpack_public_path__ + "img/chc-logo.1b3f40a3.svg";